/*

class to generate image annotation

https://www.hl7.org/fhir/datatypes.html#Annotation

{
  "state" : "<code>" // active || pending || archive || delete
  "eocId" : "<string>",
  "conditionId" : "<string>"
  "imageSetId" : "<string>",
  "imageId" : "<string>"
  "annotationId" : "<string>",
  "authorReference" : { Reference(Practitioner|Patient|RelatedPerson|Organization) },
  "authorString" : "<string>",
  "text" : "<markdown>" // R!  The annotation  - text content (as markdown)
}

*/

// Import libraries
const Joi = require('joi');

// Import variables
const { STATES } = require('@bcm/constants');
const { Annotation, annotationSchema } = require('./annotation.class');
const { joiValidateObj, identifiers } = require('../datastructComponents');

// Create schema
const schema = {
  identifier: Joi.any().optional(),
  state: Joi.string().valid( ...Object.keys(STATES) ).required(),
  eocId: Joi.string().required(),
  conditionId: Joi.string().required(),
  imageSetId: Joi.string().required(),
  imageId: Joi.string().required(),
  annotationId: Joi.string().required(),
  ...annotationSchema
};

// Define class
class ImageAnnotation extends Annotation {
  constructor ( obj ) {
    joiValidateObj(schema, obj);
    super (obj);
    this.identifier = {
      pk: identifiers.imageAnnotation.buildPk(obj.eocId, obj.conditionId, obj.imageSetId, obj.imageId),
      sk: identifiers.imageAnnotation.buildSk(obj.state, obj.eocId, obj.conditionId, obj.imageSetId, obj.imageId, obj.annotationId),
    };
  }
}

exports.ImageAnnotation = ImageAnnotation;
exports.imageAnnotationSchema = schema;